import React from 'react';

import FlareStar from 'components/generic/flare/FlareStar.component';
import TimeOffSplashTabs from 'components/hr/timeOffSplash/TimeOffSplashTabs.component';

import CN from './TimeOffSplashTabsContainer.module.scss';

const TimeOffSplashTabsContainer = () => (
  <div data-bem="TimeOffSplashTabsContainer">
    <div className={CN.sectionTitle} data-bem="TimeOffSplashTabsContainer__sectionTitle">
      <div>Do less!</div>
      <div className={CN.highlight}>
        Grow more!
        <FlareStar bottom="35" right="-9" size="22" animation="pulse" variant="dark" />
      </div>
    </div>
    <TimeOffSplashTabs />
  </div>
);

export default TimeOffSplashTabsContainer;
